<template lang="">
  <div class="paging">
    <a class="first" @click="alterPage(-2)">처음</a>
    <a class="prev" @click="alterPage(-1)">이전</a>
    <a
      v-for="page in totalPages"
      :class="{ on: page === currentPage }"
      @click="changePage(page)"
    >{{ page }}</a>
    <a class="next" @click="alterPage(1)">다음</a>
    <a class="last" @click="alterPage(2)">마지막</a>
  </div>

</template>
<script>
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },

  methods: {
    changePage (page) {
      this.$emit("changePage", page)
    },

    async alterPage(trigger) {
      switch(trigger) {
        case -2:
          if (this.currentPage === 1) break;
          this.$emit("changePage", 1)
          break;

        case -1:
        if (this.currentPage === 1) break;
        this.$emit("changePage", this.currentPage - 1)
          break;

        case 1:
        if (this.currentPage === this.totalPages) break;
        this.$emit("changePage", this.currentPage + 1)
          break;

        case 2:
        if (this.currentPage === this.totalPages) break;
        this.$emit("changePage", this.totalPages)
          break;
      }
    }
  }
    
}
</script>
<style lang="">
    
</style>